import { Link } from 'react-router-dom';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getStatusBadgeConfig } from '../../utils/taskStatusUtils';
import { formatDateForReport } from '../../helpers/formatDate';
import styles from './styles.module.css';

/**
 * TaskStatusBadge component - Displays completed task status and details
 */
export default function TaskStatusBadge({ taskData, isCompletedOnTime }) {
  const { t } = useTranslation();

  if (!taskData || (taskData.status !== 'completed' && taskData.status !== 'incompleted')) {
    return null;
  }

  const badgeConfig = getStatusBadgeConfig(
    isCompletedOnTime,
    taskData.maintenanceName,
    taskData.status,
    t
  );

  return (
    <div className={styles.fields}>
      {badgeConfig && (
        <div
          className={styles.completed}
          style={{
            backgroundColor: badgeConfig.backgroundColor,
            border: badgeConfig.border,
          }}
        >
          {badgeConfig.text}
        </div>
      )}

      {isCompletedOnTime !== null && <Divider />}

      <p className={styles.description_task}>{t('modals.comments')}:</p>
      {taskData.comment ? (
        <p className={styles.comments}>{taskData.comment}</p>
      ) : (
        <p className={styles.comments}>N/A</p>
      )}

      {taskData?.filename ? (
        <Link
          to={
            taskData.maintenanceName !== 'Report a repair'
              ? `${process.env.REACT_APP_BASE_URL}machines/filename/${taskData.filename}`
              : `${process.env.REACT_APP_BASE_URL}machines/report/${taskData.filename}`
          }
          style={{
            alignSelf: 'flex-end',
            color: '#000',
            wordBreak: 'break-word',
          }}
          target="_blank"
        >
          {taskData.original_filename}
        </Link>
      ) : (
        <p style={{ alignSelf: 'flex-end' }}>{t('modals.noFileAttached')}</p>
      )}

      <Divider />

      <p style={{ alignSelf: 'flex-end' }}>
        {t('modals.performedBy')} {taskData.responsibleFirstname} {taskData.responsibleLastname} on{' '}
        {formatDateForReport(taskData.completedAt)}
      </p>
    </div>
  );
}
